import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import LoginModal from '../../Modals/LoginModal/LoginModal';

//icons
import { Icon } from '@iconify/react';
import bxsLock from '@iconify/icons-bx/bxs-lock';

const LockedContent = ({ message }) => {
  //local state
  const [showLoginModal, setShowLoginModal] = useState(false);

  return (
    <div className="text-center w-100 p-5">
      <div className="justify-content-center align-item-center w-100 mb-3">
        <Icon icon={bxsLock} width={50} />
        <p className="text-xl my-4">{message}</p>
      </div>
      <Button onClick={() => setShowLoginModal(true)}>Sign Up</Button>
      <LoginModal showLoginModal={showLoginModal} setShowLoginModal={setShowLoginModal} action="signup" />
    </div>
  )
}

export default LockedContent
